import axios from "axios/index";
import { dispatchError, API_BASE, config as ApiConfig } from "../api";

export default store => {
  return {
    $store: store,
    list(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url:
            API_BASE +
            `/locations/${id}/morderscaware/?order_by=-creation_date`,
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    get(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/morders/" + id + "/"
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    report(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/morders/" + id + "/report/",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    report_boxes(id, params) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "get",
          url: API_BASE + "/morders/" + id + "/boxes/?order_by=box__codebar",
          params
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    },
    sync(id, status) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "put",
          url: API_BASE + "/morders/" + id + "/",
          data: {
            sync: status
          }
        })
      )
        .then(response => {
          this.$store.commit("sync", response.data);
          this.$store.commit("loading", false);

          return response;
        })
        .catch(error => {
          throw error;

          // if (error.response === undefined) {
          //   dispatchError(this.$store, 'Error de conexión. Inténtelo más tarde')
          // } else {
          //   dispatchError(this.$store, error.response.data.message)
          //   throw error
          // }
        });
    },
    addMovementOrder(params) {
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "post",
          url: API_BASE + "/morders/",
          data: { ...params }
        })
      )
        .then(response => {
          return response.data;
        })
        .catch(error => {
          throw error;
        });
    },
    deleteOrder(id) {
      this.$store.commit("loading", true);
      return axios(
        Object.assign(ApiConfig(this.$store), {
          method: "DELETE",
          url: API_BASE + `/morders/${id}/`
        })
      )
        .then(response => {
          this.$store.commit("loading", false);
          return response.data;
        })
        .catch(error => {
          if (error.response === undefined) {
            dispatchError(
              this.$store,
              "Error de conexión. Inténtelo más tarde"
            );
          } else {
            dispatchError(this.$store, error.response.data.message);
            throw error;
          }
        });
    }
  };
};
